/**
 * In-app navigation requests from deep components (record timelines, drawers) to the shell:
 * open a record, an upload batch receipt or the activity export. The shell decides where.
 */
export type NavTarget =
  | { kind: 'order' | 'company' | 'vehicle' | 'document' | 'member' | 'send' | 'shipment'; id: string; orderId?: string }
  | { kind: 'batch'; id: string; eventId?: string };
const EVENT = 'miraops-navigate';
export function navigate(target: NavTarget) { window.dispatchEvent(new CustomEvent<NavTarget>(EVENT, { detail: target })); }
export function onNavigate(handler: (t: NavTarget) => void): () => void {
  const listener = (e: Event) => handler((e as CustomEvent<NavTarget>).detail);
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
